import { fetchById, getAlgoliaIndex } from 'clients/algoliaClient';
import { SETTINGS } from 'configs/settings';
import { IBuildingObject, IGeogroupingObject } from 'types/productCatalogTypes';

export const getBuildingById = (buildingId: string): Promise<IBuildingObject | null> =>
  fetchById(getAlgoliaIndex(SETTINGS.ALGOLIA_BUILDING_INDEX), buildingId);

export const getGeogroupingById = (geogroupingId: string): Promise<IGeogroupingObject | null> =>
  fetchById(getAlgoliaIndex(SETTINGS.ALGOLIA_GEOGROUPING_INDEX), geogroupingId);
